import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Sample, SampleService } from '../../../../entities/sample';
import { AlertService } from '../../../../shared/alert/alert.service';
import { BmsjHipsterSharedLibsModule, BmsjHipsterSharedModule } from '../../../../shared';

@Component({
    selector: 'jhi-observation-sample-details-modal',
    templateUrl: './observation-sample-details-modal.component.html',
    styleUrl: './observation-sample-details-modal.component.scss'
})
export class ObservationSampleDetailsModalComponent implements OnInit {
    // Make Math available in template
    Math = Math;

    obsUnitId: string;

    constructor(private activeModal: NgbActiveModal,
                private alertService: AlertService,
                private sampleService: SampleService) {
    }

    enntries: Sample[] = [];
    maintainHeaders: boolean;

    // Pagination properties
    currentPage = 1;
    pageSize = 50;
    pageSizeOptions = [50, 75, 100];
    totalItems = 0;
    pagedData: any[] = [];

    isReloadPending = false;
    reloadTimeout: any;
    reloadDelay = 500;

    ngOnInit(): void {
        this.loadData();
    }

    /**
     * Efficiently reload table
     */
    scheduleDatasetReload(): void {
        if (this.isReloadPending) {
            // If a reload is already scheduled, reset the delay (debouncing)
            clearTimeout(this.reloadTimeout);
        } else {
            this.isReloadPending = true; // Indicate that a reload has been scheduled
        }

        // Schedule the reload after the specified delay
        this.reloadTimeout = setTimeout(() => {
            this.loadData();
            this.isReloadPending = false; // Reset pending flag after reload
        }, this.reloadDelay);
    }

    loadData() {
        this.sampleService.query({
            'obsUnitId': this.obsUnitId,
            'page': this.currentPage - 1,
            'size': this.pageSize,
            'sort': ['sampleName,asc']
        }).toPromise().then((res) => {
            this.totalItems = Number(res.headers.get('X-Total-Count'));
            this.enntries = res.body;
        });
    }


    finish() {
        this.activeModal.close();
    }

    onPageChange(page: number): void {
        this.currentPage = page;
        this.scheduleDatasetReload();
    }

    onPageSizeChange(event: any): void {
        this.pageSize = parseInt(event.target.value, 10);
        this.currentPage = 1; // Reset to first page when changing page size
        this.scheduleDatasetReload();
    }

}
